const styles = ':host{display:inline-block;position:relative}#btn{pointer-events:all}#btn[variant=tertiary]{--background:rgb(var(--colour-interactive-secondary-bg-default,245,245,245));--background-hover:rgb(var(--colour-interactive-secondary-bg-hover,223,223,223));--background-press:rgb(var(--colour-interactive-secondary-bg-pressed,204,204,204))}slot[name=custom-trigger]{display:inline-block}button.aria-button{background:none;border:0;border-radius:50%;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;margin:0;outline:none;padding:0}button.aria-button:focus-visible{box-shadow:0 0 0 4px var(--skapa-focus-ring-internal,rgb(var(--colour-neutral-1,255,255,255)));outline:2px solid var(--skapa-focus-ring-external,rgb(var(--colour-neutral-7,17,17,17)));outline-offset:4px;transition:outline .2s ease-out,box-shadow .2s ease-out}.body{--skapa-tooltip-boundary-left:0vw;--skapa-tooltip-boundary-right:100vw;--skapa-tooltip-offset:0.75rem;--skapa-tooltip-screen-edge:1.25rem;--skapa-tooltip-max-width:min(60vw,calc(var(--skapa-tooltip-boundary-right) - var(--skapa-tooltip-boundary-left) - var(--skapa-tooltip-screen-edge)*2 - var(--skapa-tooltip-padding-horizontal)*2));--skapa-tooltip-transformY:-100%;--skapa-tooltip-padding-horizontal:0.75rem;--skapa-trigger-left:50vw;--skapa-trigger-right:50vw;--skapa-trigger-center:calc(var(--skapa-trigger-left)*0.5 + var(--skapa-trigger-right)*0.5);--skapa-tooltip-overflow-x-left:calc(50% + var(--skapa-tooltip-boundary-left) + var(--skapa-tooltip-screen-edge) - var(--skapa-trigger-center));--skapa-tooltip-overflow-x-right:calc(var(--skapa-trigger-center) + 50% - var(--skapa-tooltip-boundary-right) + var(--skapa-tooltip-screen-edge));--skapa-tooltip-transformX:min(max(-50%,calc(-50% + var(--skapa-tooltip-overflow-x-left))),calc(-50% - var(--skapa-tooltip-overflow-x-right)));box-sizing:initial;display:inline-block;font-size:.75rem;left:50%;line-height:1.5;max-width:var(--skapa-tooltip-max-width);opacity:0;padding:0;position:absolute;top:.5rem;transform:translateX(var(--skapa-tooltip-transformX)) translateY(var(--skapa-tooltip-transformY));transition:transform .1s cubic-bezier(.4,0,.4,1),opacity .1s linear,padding .1s linear;visibility:hidden;width:max-content;z-index:300}.body .body-bg{background:rgb(var(--colour-elevation-3,17,17,17));border:1px solid rgb(var(--colour-elevation-2-border,72,72,72));border-radius:4px;color:rgb(var(--colour-static-white,255,255,255));display:inline-block;padding:.5rem var(--skapa-tooltip-padding-horizontal)}.body.show{opacity:1;padding:.25rem;visibility:visible}.body.show:not(.instant){transition-delay:.3s}.body--hidden{display:none}:host(:not([position])) .body.show,:host([position=""]) .body.show,:host([position=top]) .body.show{padding-bottom:calc(var(--skapa-tooltip-offset) + .5rem)}:host([position=bottom]) .body{--skapa-tooltip-transformY:0%;left:50%;top:calc(100% - .5rem)}:host([position=bottom]) .body.show{padding-top:calc(var(--skapa-tooltip-offset) + .5rem)}:host([position=leading][skapa-rtl]) .body,:host([position=trailing]:not([skapa-rtl])) .body{--skapa-tooltip-transformX:0%;--skapa-tooltip-transformY:-50%;left:calc(100% - .5rem);max-width:min(var(--skapa-tooltip-max-width),var(--skapa-tooltip-boundary-right) - var(--skapa-trigger-right) - var(--skapa-tooltip-offset) - 2 * var(--skapa-tooltip-padding-horizontal) - var(--skapa-tooltip-screen-edge));top:50%}:host([position=leading][skapa-rtl]) .body.show,:host([position=trailing]:not([skapa-rtl])) .body.show{padding-left:calc(var(--skapa-tooltip-offset) + .5rem)}:host([position=leading]:not([skapa-rtl])) .body,:host([position=trailing][skapa-rtl]) .body{--skapa-tooltip-transformX:-100%;--skapa-tooltip-transformY:-50%;left:.5rem;max-width:min(var(--skapa-tooltip-max-width),var(--skapa-trigger-left) - var(--skapa-tooltip-offset) - 2 * var(--skapa-tooltip-padding-horizontal) - var(--skapa-tooltip-screen-edge) - var(--skapa-tooltip-boundary-left));top:50%}:host([position=leading]:not([skapa-rtl])) .body.show,:host([position=trailing][skapa-rtl]) .body.show{padding-right:calc(var(--skapa-tooltip-offset) + .5rem)}@media (min-width:56.25em){:host{--skapa-tooltip-max-width:30vw}}';
import { SkapaElement } from "@ingka/skapa-webc-element";
import { IconButton } from "@ingka/button-webc/passive.js";
import { Icon } from "@ingka/icon-webc/passive.js";
import { questionMark } from "@ingka/icon-store";
import TooltipService, {
  resolveOverflow
} from "@ingka/tooltip-shared";
import {
  registerActiveTooltip,
  unregisterTooltip
} from "./tools/escapeListener.js";
import { RTLObserver, ResizeListener } from "@ingka/webc-tools";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <slot id="trigger" name="custom-trigger">
      <button aria-describedby="description" class="aria-button">
        <skapa-icon-button
          id="btn"
          size="xsmall"
          variant="tertiary"
          decorative-only
          role="none"
        >
          <slot slot="icon" name="icon">
            <skapa-icon icon="question-mark"></skapa-icon>
          </slot>
          <slot name="label"></slot>
        </skapa-icon-button>
      </button>
    </slot>
    <span class="body body--hidden" role="none">
      <slot class="body-bg" role="tooltip" id="description"></slot>
    </span>
  `;
  return { main: template };
}
const listenerTypes = ["mouseover", "mouseout", "focusin", "focusout"];
function listeners(target, on) {
  const listenerType = on ? target.addEventListener.bind(target) : target.removeEventListener.bind(target);
  listenerTypes.map((eventType) => listenerType(eventType, target.handleHover));
  listenerType("click", target.handleClick);
}
class Tooltip extends SkapaElement {
  constructor() {
    super();
    this.handleClick = (ev) => {
      if (!this.toggle)
        return;
      if (!ev.composedPath().includes(this.triggerContainer))
        return;
      const button = this.ariaButton;
      const nextState = !(button.ariaPressed === "true");
      this.toggleTooltip(nextState);
    };
    /** Controls the component's button styles, aria-pressed state and escape key listener based on the provided toggle state. */
    this.toggleTooltip = (on) => {
      this.ariaButton.ariaPressed = on.toString();
      this.iconButton.setAttribute("variant", on ? "primary" : "tertiary");
      if (on) {
        this.showTooltip();
        registerActiveTooltip(this);
      } else {
        this.hideTooltip();
        unregisterTooltip(this);
      }
    };
    /** Updates the overflow correction value in the component and in css as well. */
    this.resolveOverflow = () => {
      resolveOverflow(this.triggerContainer, this.tooltipBody, this.boundaryId);
    };
    /** Displays tooltip */
    this.showTooltip = () => {
      this.resolveOverflow();
      if (this.toggle || TooltipService.preventTransition && this.quickPreview)
        this.tooltipBody.classList.add("instant");
      this.tooltipBody.classList.toggle("show", true);
    };
    /** Hides tooltip */
    this.hideTooltip = () => {
      this.tooltipBody.classList.remove("instant");
      if (this.tooltipBody.classList.contains("show")) {
        TooltipService.setTooltipGroupTimer();
      }
      this.tooltipBody.classList.toggle("show", false);
    };
    this.handleHover = (ev) => {
      if (this.toggle)
        return;
      if (ev.currentTarget !== this)
        return;
      if (["mouseover", "focusin"].includes(ev.type)) {
        this.showTooltip();
      } else {
        this.hideTooltip();
      }
    };
    this.gatherProperties(["position", "toggle", "quickPreview"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const { main } = this.getTemplates(generateTemplate);
    shadow.append(main.content.cloneNode(true));
    this.tooltipBody = shadow.querySelector(".body");
    this.iconButton = shadow.querySelector("#btn");
    this.ariaButton = shadow.querySelector(".aria-button");
    this.triggerContainer = shadow.querySelector("#trigger");
  }
  static get observedAttributes() {
    return ["toggle", "boundaryId", "quick-preview"];
  }
  /** On mount */
  connectedCallback() {
    super.connectedCallback();
    listeners(this, true);
    ResizeListener.addResizeListener(this.resolveOverflow);
    RTLObserver.addTarget(this);
    this.resolveOverflow();
    this.tooltipBody.classList.remove("body--hidden");
  }
  /** On dismount */
  disconnectedCallback() {
    super.disconnectedCallback();
    listeners(this, false);
    RTLObserver.removeTarget(this);
    ResizeListener.removeResizeListener(this.resolveOverflow);
    this.tooltipBody.classList.add("body--hidden");
  }
  attributeChangedCallback(attribute, oldVal, newVal) {
    if (attribute === "toggle" && !newVal)
      this.toggleTooltip(false);
    if (attribute === "boundaryId")
      this.resolveOverflow();
  }
  get position() {
    return this.getAttribute("position") || "top";
  }
  set position(value) {
    if (!value)
      this.removeAttribute("position");
    else
      this.setAttribute("position", value);
  }
  get toggle() {
    return this.hasAttribute("toggle");
  }
  set toggle(val) {
    this.toggleAttribute("toggle", !!val);
  }
  get boundaryId() {
    return this.getAttribute("boundaryId");
  }
  set boundaryId(id) {
    if (id)
      this.setAttribute("boundaryId", id);
    else
      this.removeAttribute("boundaryId");
  }
  get quickPreview() {
    return this.getAttribute("quick-preview") !== "false";
  }
  set quickPreview(val) {
    if (val === false)
      this.setAttribute("quick-preview", "false");
    else
      this.removeAttribute("quick-preview");
  }
}
Tooltip.skapaTagName = "tooltip";
Tooltip.skapaDependencies = [IconButton, Icon];
Tooltip.skapaIconDependencies = [questionMark];
export {
  Tooltip
};
